import { createFileRoute } from '@tanstack/react-router';
import { findNavItem } from '@/shared/patterns/AppShell';
import { creditNav } from '@/domains/credit';
import { UnderConstruction } from '@/shared/components/UnderConstruction';

// Catch-all temporal: cada item del sidebar cae aquí hasta que su pantalla real lo reemplace
// con una ruta propia (p.ej. `_backoffice.credit.portfolio.tsx`).
export const Route = createFileRoute('/_backoffice/credit/$section')({
    component: CreditSection,
});

function CreditSection() {
    const { section } = Route.useParams();
    return <UnderConstruction title={findNavItem(creditNav, section)?.label ?? section} />;
}
